export default __webpack_public_path__ + "static/vow-career-2-10fe03c6397f64069506bb906a4c86f6.jpg";